'use client';

import { useState } from 'react';
import { useAuth } from 'react-oidc-context';

import { Flex } from '@zoomit/primitives';
import type {
  BaseImageType,
  ReviewInfoResponseType} from '@zoomit/web-kit';
import {
  Rating,
  UnauthorizedModal,
  isMobile,
  useHistoryState,
} from '@zoomit/web-kit';
import { Typography, cssVar, theme } from '@zoomit/zoomit-ds';

import ReviewTopicModal from './ReviewModal';

type Props = {
  id: string;
  cover: BaseImageType;
  title: string;
  slug: string;
  minCharacter?: number;
  reviewData: ReviewInfoResponseType | undefined;
};

const ReviewRatingBox = (props: Props) => {
  const { id, cover, title, slug, minCharacter, reviewData } = props;
  const [rate, setRate] = useState(reviewData?.review?.score || 0);

  const { isAuthenticated } = useAuth();

  const unauthorizedModalState = useHistoryState<boolean>({
    id: 'review-rating-box-unauth-modal',
    initialState: false,
  });

  const reviewPopupState = useHistoryState<boolean>({
    id: 'review-rating-box-modal',
    initialState: false,
  });

  const handleSelectRate = (rate: number) => {
    if (!isAuthenticated) {
      unauthorizedModalState.open();
    } else {
      setRate(++rate);
      reviewPopupState.open();
    }
  };

  return (
    <div className="border-grey6 bg-background2 hover:bg-background1 flex h-[128px] flex-col items-center justify-between gap-2 rounded-md border px-2 pt-4 pb-3 sm:w-[164px] md:flex md:h-[72px] md:items-start md:gap-0 md:px-3 md:py-3 lg:w-[179px]">
      <Rating
        rate={reviewData?.review?.score || 0}
        onSelect={(rate) => handleSelectRate(rate)}
        size={isMobile ? 'md' : 'dl'}
      />
      <Flex flexDirection="column" alignItems="center">
        {isMobile && (
          <Typography variant="subhead-bold" lineHeight={2}>
            {reviewData?.review ? (
              <Typography className="fa" fontSize={1.4} variant="subhead" fontWeight="bold">
                {reviewData.review.score}
                <Typography fontSize={1.3} textColor={cssVar(theme.grey1)} className="fa" fontWeight="bold">
                  /5
                </Typography>
              </Typography>
            ) : (
              'امتیاز دهید'
            )}
          </Typography>
        )}
        <Typography variant="subhead" lineHeight={2} textColor={cssVar(theme.grey1)}>
          {reviewData?.review ? 'امتیاز و نظر شما' : 'امتیاز و نظر دهید'}
        </Typography>
      </Flex>
      {reviewData && (
        <ReviewTopicModal
          topicType="Product"
          topicInfo={{
            topicId: id,
            topicSlug: `product/${slug}`,
            topicTitle: title,
          }}
          onClose={() => reviewPopupState.close()}
          isOpen={reviewPopupState.isOpen}
          image={cover}
          title={title}
          rate={rate}
          minCharacter={minCharacter}
        />
      )}
      <UnauthorizedModal
        isOpen={unauthorizedModalState.isOpen}
        onClose={() => unauthorizedModalState.close()}
      />
    </div>
  );
};

export default ReviewRatingBox;
